import React, { Component } from "react";

export default class PaymentMethods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: props.options,
    };
  }

  render() {
    return (
      <>
        <option value="">Payment Options</option>
        {this.state.options.length
          ? this.state.options.map((item, index) => {
              return (
                <option value={item.key} key={item.key}>
                  {item.title}
                </option>
              );
            })
          : null}
      </>
    );
  }
}
